<app-template *ngIf="!isIEOrEdge">

    <!-- FAD MASIVO DESKTOP -->
    <div class="fad-desktop" *ngIf=" isMobile === false && isTablet === false ">

        <div class="video-home">
            <video width="100%" height="100%" loop="loop" autoplay="autoplay" [muted]="true" muted="muted"
                   oncontextmenu="return false;">
                <source src="assets/images/Video.webm" type="video/webm">
            </video>
            <img src="assets/images/pleca.png" alt="">
            <div class="titulo">
                <h1><p>Comece a <span>assinar</span><br><span>com FAD®</span></p></h1>
                <div class="boton" (click)="openVideo()"><img src="assets/images/icon_play.png" alt="Play">
                    Veja como funciona
                </div>
            </div>
        </div>

        <div class="banner-mapa">
            <img width="100%" height="auto" src="assets/images/mapa_fad.png" alt="">
            <div class="title">
                <p>Países que já assinam com <span>FAD®</span></p>
            </div>
        </div>

        <div class="principal-section">
            <div class="img-principal2"></div>
            <div class="side image-background">
                <div class="data">
                    <div class="title">
                        <p>Nós somos a plataforma de assinatura
                            <br><br><span>MAIS SEGURA DO MUNDO</span></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="principal-section">
            <div class="img-principal3">
                <div class="wraper">
                    <div class="data">
                        <div class="description">
                            <p>
                                <span>Crie uma conta sem<br>compromisso</span>, conheça FAD® e...<br><br>
                            </p>
                        </div>
                        <div class="title">
                            <p>Receba
                                <span>3 assinaturas GRÁTIS</span></p>
                        </div>
                        <div class="actions red" (click)="freeTest()">
                            <div class="preview">
                                <p>
                                    CRIE SUA CONTA AGORA!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="side imagen-prin">
                <img src="assets/images/firma-prin3.png" alt="">
            </div>
        </div>

        <div class="sign-any-document">
            <div class="max-width">
                <p>
                    <span>Assine qualquer documento do seu smartphone,</span> <br> não importa onde você esteja.
                    100% seguro. 100% atribuível. 100% legal.<br>
                </p>
            </div>
        </div>

        <div class="products">
            <div class="container max-width">
                <div class="product">
                    <mat-card>
                        <div class="image">
                            <img mat-card-image src="assets/images/fad_personal.png" alt="FAD Personal">
                            <div class="text">
                                <p>FAD® pessoal</p>
                            </div>
                        </div>
                        <mat-card-content>
                            <p class="description">
                                <strong>Inclui processo patenteado:</strong><br>
                                Vídeo Assinatura, vídeo de aceitação do acordo, constância de conservação
                                <br>
                                <strong>Suporte:</strong><br>
                                N1 Call center de segunda a sexta das 8h às 20h.
                                <br>
                                <strong>Inclui:</strong><br>
                                Apenas aplicativo nativo (iOS e Android)
                            </p>

                        </mat-card-content>
                    </mat-card>
                </div>

                <div class="product">
                    <mat-card>
                        <div class="image">
                            <img mat-card-image src="assets/images/fad_empresa.png" alt="FAD Empresa">
                            <div class="text">
                                <p>FAD® empresarial</p>
                            </div>
                        </div>
                        <mat-card-content>
                            <p class="description">
                                <strong>Inclui processo patenteado:</strong><br>
                                Vídeo Assinatura, vídeo de aceitação do acordo, constância de conservação<br>
                                <strong>Suporte:</strong><br>
                                N1 Call center de segunda a sexta das 8h às 20h. (N2 com custo extra)
                                <br>
                                <strong>Inclui:</strong><br>
                                App Nativo (iOS e Android)
                                <br><strong style="font-size: 16px;">* Você pode adquirir Versão Web, SDK e API
                                separadamente</strong>
                            </p>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
        </div>

        <div class="pricing-list">
            <div class="container max-width">
                <div class="panel">
                    <mat-expansion-panel id="ver_plan_persona_inicio" hideToggle
                                         (click)="addDataLayerClicProducto(1)">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <p>VER PLANOS E CONTRATAR</p>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="content-panel">

                        </div>
                    </mat-expansion-panel>
                </div>
                <div class="panel">
                    <mat-expansion-panel id="ver_plan_empresa_inicio" hideToggle
                                         (click)="addDataLayerClicProducto(2)">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <p>VER PLANOS E CONTRATAR</p>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="content-panel">
                        </div>
                    </mat-expansion-panel>
                </div>
            </div>
        </div>

        <div class="principal-section">
            <div class="img-principal4">
                <div class="wraper">
                    <img width="140%" src="assets/images/clientes-pc.png" alt="">
                </div>
            </div>
            <div class="imagen-prin1">
                <div class="description">
                    <p>
                        Para <span>configurar um documento</span> e assinar com FAD®
                    </p>
                </div>
                <br>
                <div class="title">
                    <p>você só precisa inserir:<br>
                        <span><a href="https://clientes.firmaautografa.com/login" target="_blank">clientes.firmaautografa.com</a></span>
                    </p>
                </div>
            </div>
        </div>

        <div class="use-cases max-width">
            <p class="title max-width">
                Saiba como <span>FAD®</span> pode ajudar a <span>dar segurança e certeza jurídica</span> a qualquer um
                dos <span>processos, acordos e documentos</span> de diferentes indústrias
            <div class="contain-absolute">
                <div><img width="100%" src="assets/images/_DSC6336.png" alt=""></div>
                <div class="text">
                    <p><span>IMOBILIÁRIO - COMPRA / VENDA DE IMÓVEIS</span></p>
                    <p>Assinatura eletrônica para contratos de compra, venda ou aluguel de imóveis com vídeo assinatura,
                        vídeo de aceitação do acordo, geolocalização e constância de conservação aprovado pelas
                        autoridades...</p>
                    <hr>
                </div>
                <div><img width="100%" src="assets/images/_DSC3528.png" alt=""></div>
                <div class="text">
                    <p><span>AUTOMOBILÍSTICO - COMPRA / VENDA DE AUTOMÓVEIS</span></p>
                    <p>Celebração de contratos de compra, venda ou locação de automóveis, seja diretamente com agência,
                        seja entre pessoas físicas. O processo possui vídeo assinatura, vídeo de aceitação do acordo,
                        geolocalização e constância de conservação aprovado pelas autoridades...</p>
                    <hr>
                </div>
                <div><img width="100%" src="assets/images/_DSC6689.png" alt=""></div>
                <div class="text">
                    <p><span>BANCOS - CARTÃO DE CRÉDITO</span></p>
                    <p>Assinatura eletrônica para contratação de cartões de crédito com vídeo assinatura, vídeo de
                        aceitação do acordo, geolocalização e constância de conservação aprovado pelas
                        autoridades...</p>
                    <hr>
                </div>
                <div><img width="100%" src="assets/images/_DSC5357.png" alt=""></div>
                <div class="text">
                    <p><span>ASSINATURA DE CONTRATOS COM FORNECEDORES</span></p>
                    <p>Assinatura eletrônica de contratos de cadastro de fornecedores com vídeo assinatura, vídeo de
                        aceitação do acordo, geolocalização e constância de conservação aprovado pelas
                        autoridades...</p>
                    <hr>
                </div>
                <div><img width="100%" src="assets/images/_DSC660.png" alt=""></div>
                <div class="text">
                    <p><span>ASSINATURA DE CONTRATOS LABORAIS</span></p>
                    <p>Assinatura eletrônica de contratos de registro ou rescisão de contrato de trabalho, férias,
                        sigilo, entre muitos outros. O processo conta com vídeo assinatura, vídeo de aceitação do
                        acordo, geolocalização e constância de conservação aprovado pelas autoridades...</p>
                    <hr>
                </div>
                <div><img width="100%" src="assets/images/_DSC5370.png" alt=""></div>
                <div class="text">
                    <p><span>ASSINATURA DE CONTRATOS COM CLIENTES</span></p>
                    <p>Assinatura eletrônica de contratos de compra /venda, andamento do projeto, sigilo, entre muitos
                        outros. O processo conta com vídeo assinatura, vídeo de aceitação do acordo, geolocalização e
                        constância de conservação aprovado pelas autoridades...</p>
                    <hr>
                </div>
            </div>
            <p class="title max-width">
                Descubra todos os casos de uso <span>FAD®</span> e torne-se um
                <span>embaixador da transformação digital</span> em sua empresa.
            </p>
            <div class="contain-cases-button">
                <p class="title max-width">
                    VER TUDO O QUE <br><span>POSSO FAZER COM FAD®</span></p>
                <div id="ver_casos_usos" class="more-cases" (click)="moreUseCases()">
                    <p>VER MAIS CASOS DE USO</p>
                </div>
            </div>
        </div>

        <div class="steps">
            <p class="title max-width">
                Como <span>adquirir o plano de assinatura</span> que melhor <br>
                se adapta às suas necessidades, em apenas 4 etapas?
            </p>
            <div class="steps-container max-width">
                <div class="step">
                    <div class="header">
                        <div class="number">
                            <p>01</p>
                            <img src="assets/images/Rectangle.png" alt="Rectangle">
                        </div>
                        <div class="name">
                            <p>Escolha entre</p>
                        </div>
                    </div>
                    <div class="content">
                        <p>
                            FAD® Pessoal ou <br> FAD® Empresarial
                        </p>
                        <img src="assets/images/step_1.png" alt="Step image">
                    </div>
                </div>

                <div class="step">
                    <div class="header">
                        <div class="number">
                            <p>02</p>
                            <img src="assets/images/Rectangle.png" alt="Rectangle">
                        </div>
                        <div class="name">
                            <p>Escolha</p>
                        </div>
                    </div>
                    <div class="content">
                        <p>
                            O tipo de assinatura que melhor se adapta ao seu negócio ou empresa.
                        </p>
                        <img src="assets/images/step_2.png" alt="Step image">
                    </div>
                </div>

                <div class="step">
                    <div class="header">
                        <div class="number">
                            <p>03</p>
                            <img src="assets/images/Rectangle.png" alt="Rectangle">
                        </div>
                        <div class="name">
                            <p>Contate-nos</p>
                        </div>
                    </div>
                    <div class="content">
                        <p>
                            Via WhatsApp...
                        </p>
                        <img src="assets/images/step_4.png" alt="Step image">
                    </div>
                </div>

                <div class="step">
                    <div class="header">
                        <div class="number">
                            <p>04</p>
                            <img src="assets/images/Rectangle.png" alt="Rectangle">
                        </div>
                        <div class="name">
                            <p>Aproveite seu plano</p>
                        </div>
                    </div>
                    <div class="content">
                        <p>
                            <strong>Se você deseja adicionar funcionalidades extras, entre em contato conosco via
                                WhatsApp...</strong>
                        </p>
                        <img src="assets/images/step_3.png" alt="Step image">
                    </div>
                </div>

            </div>
        </div>

        <div class="complement">
            <p class="title max-width">
                <span>Complemente o seu plano de assinatura eletrônica com os seguintes</span><br><span>recursos extras (Add-Ons)</span>,
                que o ajudarão a criar uma solução perfeita para você:
            </p>
            <div class="complements max-width">


                <div class="item">
                    <img src="assets/images/otp_whatsap.png" alt="Videoacuerdo">
                    <div class="data">
                        <p class="title">OTP vía WhatsApp</p>
                        <p class="description">Envio de um código de uso único pelo WhatsApp, para que o signatário abra
                            o documento a ser assinado no aplicativo móvel ou web</p>
                    </div>
                </div>

                <div class="item">
                    <img src="assets/images/version_web.png" alt="Videoacuerdo">
                    <div class="data">
                        <p class="title">Versão WEB</p>
                        <p class="description">O signatário pode assinar documentos de qualquer navegador móvel sem
                            baixar nenhum aplicativo</p>
                    </div>
                </div>

                <div class="item">
                    <img src="assets/images/foto_ine.png" alt="Videoacuerdo">
                    <div class="data">
                        <p class="title">Captura de identificação</p>
                        <p class="description">Fotografia de identificação em ambos os lados</p>
                    </div>
                </div>

                <div class="item">
                    <img src="assets/images/blockchain.png" alt="Videoacuerdo">
                    <div class="data">
                        <p class="title">Constância de conservação em Blockchain</p>
                        <p class="description">Certificado registrado em Ethereum que garante que o documento assinado
                            não será alterado</p>
                    </div>
                </div>

                <div class="item">
                    <img src="assets/images/compara_videoacuerdo.png" alt="Videoacuerdo">
                    <div class="data">
                        <p class="title">Comparação do vídeo de aceitação do acordo</p>
                        <p class="description">Comparação entre a face do assinante durante o acordo de vídeo e a foto
                            que aparece na identificação</p>
                    </div>
                </div>

                <div class="item">
                    <img src="assets/images/compara_videofirma.png" alt="Videoacuerdo">
                    <div class="data">
                        <p class="title">Comparação da Vídeo Assinatura</p>
                        <p class="description">Comparação entre o rosto do signatário durante a assinatura do vídeo e a
                            foto que aparece na identificação</p>
                    </div>
                </div>

                <div class="item">
                    <img src="assets/images/comparacion_firma.png" alt="Videoacuerdo">
                    <div class="data">
                        <p class="title">Comparação de assinatura</p>
                        <p class="description">Comparação entre a assinatura na identificação e a assinatura feita com o
                            dedo ou caneta touch</p>
                    </div>
                </div>

                <div class="item">
                    <img src="assets/images/notificacion.png" alt="Videoacuerdo">
                    <div class="data">
                        <p class="title" style="color: #a80a34;">Considerações importantes</p>
                        <p class="description">
                            1. Para fazer comparações de contrato de vídeo, assinatura de vídeo e assinatura, é
                            necessário adquirir a Captura de Identificação.<br>
                            2. Para adquirir Add-Ons, solicite-os com seu consultor de vendas por um custo extra.
                        </p>
                    </div>
                </div>

            </div>
        </div>

        <div class="legal-compliance">
            <div class="backdrop"></div>
            <div class="text">
                <p>A Assinatura Autógrafa Digital® <span>está em conformidade <br>
                com a Medida Provisória No 2.200-2, LGPD,<br>
                as leis da UNCITRAL (ONU) e os novos regulamentos eIDAS, US ESIGN e UETA & ESIGN Act,</span>
                    entre outros regulamentos</p>
                <div id="ver_cumplimieno_legal" class="button-more"
                     [routerLink]="['/conformidade-legal-da-assinatura-digital']">
                    <p>VEJA MAIS SOBRE CONFORMIDADE LEGAL</p>
                </div>
            </div>
        </div>

        <div class="characteristics">
            <p class="title max-width">
                <span>FAD®</span> é a <span>assinatura digital mais utilizada na América Latina</span>, pois possui os
                seguintes diferenciais exclusivos:
            </p>
        </div>

        <div class="characteristics-image max-width">
            <div class="contain-absolute">
                <div class="column white">
                    <mat-card>
                        <mat-card-content>
                            <div class="item">
                                <p class="principal">
                                    3 minutos
                                </p>
                                <p class="important">
                                    é o tempo que leva para assinar um documento com FAD®
                                </p>
                            </div>
                            <div class="item">
                                <p class="principal">
                                    100% legal
                                </p>
                                <p class="important">
                                    a única assinatura digital comprovada <br>em tribunal
                                </p>
                            </div>
                            <div class="item">
                                <p class="principal">
                                    Economize 90%
                                </p>
                                <p class="important">
                                    do tempo investido em seus processos <br>de assinatura
                                </p>
                            </div>
                            <div class="important">
                                <div class="more-cases" (click)="freeTest()">
                                    <p>QUERO UMA AVALIAÇÃO GRATUITA</p>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
                <div class="column"></div>
            </div>
            <div class="white"></div>
            <div class="image">
                <img src="assets/images/diferenciadores.png" alt="Características">
            </div>
        </div>

        <div class="are-you-ready">
            <p class="title max-width">
                Pronto para <span>começar a assinar documentos<br>digitalmente com FAD®?</span> Selecione a opção que
                melhor<br>se adeque às suas necessidades:
            </p>
            <div class="options">
                <div class="container max-width">
                    <div class="item">
                        <img src="assets/images/fad_personal_thin.png" alt="FAD personal">
                        <div class="contain">
                            <p class="title">
                                FAD® pessoal
                            </p>
                            <p class="description">
                                <strong>Inclui processo patenteado:</strong><br>
                                Vídeo Assinatura, vídeo de aceitação do acordo, Constância de conservação
                                <br>
                                <strong>Suporte:</strong><br>
                                N1 Call center de segunda a sexta das 8h às 20h.
                                <br>
                                <strong>Inclui:</strong><br>
                                Apenas aplicativo nativo (iOS e Android)
                            </p>

                        </div>
                    </div>
                    <div class="item">
                        <img src="assets/images/fad_empresa_thin.png" alt="FAD personal">
                        <div class="contain">
                            <p class="title">
                                FAD® empresarial
                            </p>
                            <p class="description">
                                <strong>Inclui processo patenteado:</strong><br>
                                Vídeo Assinatura, vídeo de aceitação do acordo, Constância de conservação
                                <br>
                                <strong>Suporte:</strong><br>
                                N1 Call center de segunda a sexta das 8h às 20h. (N2 com custo extra)
                                <br>
                                <strong>Inclui:</strong><br>
                                App Nativo (iOS e Android)
                                <br><strong style="font-size: 16px;">* Você pode adquirir Versão Web, SDK e API
                                separadamente</strong>
                            </p>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="pricing-list-bottom">
            <div class="container max-width">
                <div class="panel">
                    <mat-expansion-panel id="ver_plan_persona_fin" hideToggle
                                         (click)="addDataLayerClicProducto(1)">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <p>VER PLANOS E CONTRATAR</p>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="content-panel">

                        </div>
                    </mat-expansion-panel>
                </div>
                <div class="panel">
                    <mat-expansion-panel id="ver_plan_empresa_fin" hideToggle
                                         (click)="addDataLayerClicProducto(2)">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <p>VER PLANOS E CONTRATAR</p>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="content-panel">

                        </div>
                    </mat-expansion-panel>
                </div>
            </div>
        </div>

        <div class="clients">
            <p class="title">
                Eles já usam <span>Assinatura Autógrafa Digital</span>
            </p>
            <div class="clients-images max-width">
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/1-A_C Contruccion.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/2-logo-abc-capital.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/3-logo-abisa.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/5-acil-mexico.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/6-acium.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/7-Actinver.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/8-advex.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/9-alianza-financiera-social.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/10-logo-alorica.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/11-logo-alpez.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/12-alpha credit.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/13-logo-amda.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/16-amex-corp.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/17-Anfexi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/18-aplika.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/19-arc-canto.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/20-logo-seguro-bx.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/22-arrendamiento-seguro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/23-arvizu-benitez.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/24-Aseguranzza.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/25-Aser promotora.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/26-aserta.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/27-ARCA.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/28-logo-asf.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/29-logo-atlas-desarrollos.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/30-logo-atradius.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/31-logo-attendo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/32-logo-axa-seguros.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/33-logo-ayudate.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/34-logo-aqua-farms.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/35-BAM.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/36-logo-mifel.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/37-Banco BASE.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/38-logo-bancoppel.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/39-bancosol.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/40-logo-bank-america.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/41-logo-bankingly.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/42-banorte.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/43-Banorte casa bolsa.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/44-Banregio.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/45-BC credit.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/46-logo-be-grand.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/47-logo-best-doctors.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/48-logo-blac-solutions.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/49-logo-blic.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/50-logo-blue-services.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/52-Boss.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/53-Boxnsuites.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/54-logo-brada.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/55-logo-britannia.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/57-BX.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/58-Capgemini.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/59-logo-casa-equis.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/60-logo-cementos-moctezuma.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/61-logo-central.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/62-CIBando.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/63-logo-club-de-rentas.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/64-logo-cooperativa-ahorro-credito.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/65-Corporacion multivac.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/66-logo-credenz.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/67-logo-credicaor.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/68-credifiel.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/69-logo-credijusto.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/70-credimon.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/71-logo-credit-suisse.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/72-Creditea.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/73-inversiones cuantico.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/74-logo-dafi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/75-logo-daimler.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/77-Dicofra.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/78-DigitNow.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/79-Dycsi.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/80-logo-bebe.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/81-logo-educacion.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/83-logo-engie.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/84-logo-epicbanc.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/85-escuela-idiomas.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/87-logo-fanda.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/88-logo-farmalisto.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/89-logo-fergo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/90-logo-figlosnte.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/91-Fimeco.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/92-logo-finacciona.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/93-logo-finamex.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/94-Finvivir.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/95-forjadores.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/96-logo-formatres38.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/97-logo-garantia-de-renta.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/98-logo-gas-royal.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/99-gemalto.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/101-logo-gm.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/102-GNP.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/103-Grupak.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/104-logo-grupo-aguacatero.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/105-Grupo Barvis.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/106-Grupo CTP.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/107-logo-empresarial-angeles.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/108-logo-grupo-garsa.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/109-logo-larrarte.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/110-logo-grupo-mk.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/111-logo-grupo-renovables.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/112-logo-tangassi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/113-logo-grupo-tierra-maya.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/114-logo-veintiuno cero.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/115-logo-vigia.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/116-logo-fintex.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/117-logo-salazar-seguros.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/119-logo-ideaconv.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/120-Impulso distrito.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/121-logo-inmobiliaria.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/122-Invex.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/123-logo-ipack.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/124-logo-jp-morgan.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/125-logo-jubicom.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/126-logo-karum.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/127-Kondinero.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/128-logo-lyl-servicios.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/129-logo-castellana.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/130-Lacerta.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/131-Lanapay.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/132-Lecto.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/133-liceo-britanico.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/134-logo-liftit.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/135-logo-lockton.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/136-logo-maletin-financiero.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/137-logo-maple-respiratory.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/138-logo-marnez.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/140-logo-maslow.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/141-logo-medica-movil.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/142- logo-medworks.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/143-logo-femsa.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/144-Metrocarrier.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/145-Mexidooro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/147-monex.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/149-Banco Multiva.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/150-logo-mvs-radio.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/151-Natgas.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/152-NewYorkLife.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/153-logo-novo-media.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/154-Oak leasing.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/155-logo-orbia.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/156-logo-pa-despues.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/157-logo-pichincha.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/158-logo-potenciadora.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/159-logo-power-golden.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/161-Proagro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/162-profuturo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/163-logo-proton.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/164-prudential.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/165-logo-consultoria-juridica.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/166-logo-red-girasol.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/167-Rilmliving.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/168-logo-roadis.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/169-Rockteck.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/170-logo-santander.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/172-seguros atlas.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/173-logo-seguros-potosi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/175-servnet.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/177-Sicrea.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/178-logo-soluciones-industriales.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/179-logo-sotiderc.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/181-logo-spt-seguros.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/182-SR pago.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/183-logo-srobredo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/184-logo-start-credit.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/185-logo-storm-group.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/186-Supplycredit.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/187-Sura.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/188-logo-tcpip.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/189-logo-tec.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/190-Tecsup.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/192-logo-thales.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/194-logo-tintorerias-max.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/196-todo-a-dollar.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/197-logo-torres-corzo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/198-Toyota.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/199-Tucasaexpress.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/200-Value.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/201-Vantis.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/202-Vavilco.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/203-Vector bolsa.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/204-logo-viac.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/205-Viajes el corte ingles.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/206-logo-vidacel.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/207-logo-vivaness.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/208-logo-vwfs.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/209-logo-yo-dispongo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/210-logo-zavala-aguilar.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/211-logo-compartamos.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/212-logo-axtelcorp.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/213-GENTERA_logotipo.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/216-logo-globalps.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/217-logo-amado.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/218-logo-fibrax.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/219-naturalle-inter.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/220-quality-copy.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/221-logo-lirmi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/222-logocg-systems.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/223-logo-4r.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/224-logo-ciclos.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/225-logo-amig.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/226-logo-vip.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/227-logo-hotamsat.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/229-logo-nhit.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/230-logo-koi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/232-logo-olian.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/233-logo-nova-aluminio.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/234-logo-supercredi.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/236-logo-investockly.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/237-logo-cj-prado.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/238-logo-insignia.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/239-logo-mysourcing.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/241-logo-cemex.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/242-logo-lacuna.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/243-logo-urban-town.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/244-logo-finser.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/246-logo-tu-hogar.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/248-logo-ecomaster.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/249-viena-imoveis.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/250-logo-saucer.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/251-logo-maia.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/252-logo-rodrigo-cesar.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/253-logo-lorian.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/254-logo-colegio-brasileiro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/255-logo-ambaya.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/256-logo-yastas.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/257-logo-grupo.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/258-logo-micro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/260-logo-yanapana.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/261-logo-produbanco.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/262-logo-segurosaurora.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/264-logo-lalonja.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/265-logo-unispan.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/268-logo-instituto-barong.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/269-logo-ubicanton.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/271-logo-ektaris.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/272-logo-camargo-agronegocios.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/273-logo-fundacion-social.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/274-logo-crescendo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/275-logo-zenbyte.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/276-logo-cafeyna.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/277-logo-emprenet.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/279-logo-eldefiar.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/281-logo-dinamica-logistica.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/282-logo-ubiqo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/283-logo-softvaro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/284-logo-w2b.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/286-logo-escritorio-ribeiro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/288-logo-noli-imoveis.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/289-logo-diartrading.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/292-logo-gestacore.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/294-logo-seguridad-total.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/295-logo-hekobi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/296-logo-nova-select.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/297-logo-educando.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/298-logo-colegio-monte.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/300-logo-jamka.png" alt=""></div>
            </div>
        </div>
    </div>

    <!-- FAD MASIVO RESPONSIVO -->
    <div class="fad-movil" *ngIf=" isMobile === true || isTablet === true ">

        <div class="box-container">
            <div class="title-img">
                <div class="box">
                    <div class="wrapper"></div>
                </div>

                <div class="box-border"></div>

                <div class="box-img">
                    <img class="img-prin" src="assets/images/m/welcome.png">
                </div>

                <div class="box-inv">
                    <div class="wrapper"></div>
                </div>
            </div>

            <div class="content-res">
                <h1>Assinatura Autógrafa Digital®</h1>
                <img style="margin: 0px auto 10px" width="150px" src="assets/images/FAD-ISO-27001.png" alt="ISO 27001">
                <h2>
                    <p class="title">A ASSINATURA DIGITAL<br><span>MAIS CONFIÁVEL</span><br>DA AMÉRICA LATINA</p>
                </h2>
                <div class="line"></div>
                <p>e provavelmente do mundo...</p>
            </div>

            <div class="content-res">
                <p class="title" style="text-align: left; padding: 10px">Países que já assinam com <span>FAD®</span></p>
                <img width="100%" height="auto" src="assets/images/mapa_fad.png" alt="">
            </div>

            <div class="content-general">
                <p class="title-secondary no-space">Por que é<br><span>superior aos outros?</span></p>
            </div>

            <div class="content-video">
                <iframe id="video_romantico_movil" src="https://www.youtube.com/embed/uj5uQ-gLyvQ" frameborder="0"
                        allow="autoplay; encrypted-media; picture-in-picture"
                        allowfullscreen></iframe>
            </div>

            <div class="img-header">
                <div class="box-middle-top">
                    <div class="content-general"><p class="title-secondary"><span>Assine qualquer</span><br><span> documento</span>
                        de <br>qualquer lugar</p></div>
                </div>
                <div class="box-middle-down"></div>
                <div class="center">
                    <img src="assets/images/m/phonefirma.png" alt="">
                </div>
            </div>

            <div class="content-general">
                <ul class="content-list square">
                    <li><br>100% legal</li>
                    <p>única assinatura digital comprovada em processos judiciais</p>
                    <li><br>100% atribuível</li>
                    <p>só você pode assinar o seu nome, ninguém mais</p>
                    <li><br>100% seguro</li>
                    <p>seus documentos assinados nunca serão alterados</p>
                </ul>
            </div>

            <div style="margin: auto; height: 2px; width: 266px; background-color: #DCDCDC;"></div>

            <div class="img-header">
                <div class="content-general">
                    <p class="title-secondary">
                        Para configurar<br><span>um documento<br>e assinar<br>com FAD®</span></p>
                    <br>
                    <p class="solo-debes-ingresar">você só precisa inserir:<br>
                        <a href="https://clientes.firmaautografa.com/login"
                           target="_blank">clientes.firmaautografa.com</a>
                    </p>
                    <p class="solo-debes-ingresar">
                        <br>

                        Certifique-se <span>de fazer isso de um computador desktop</span>
                    </p>
                    <img width="320px" style="margin-top: 70px" src="assets/images/clientes-pc.png" alt="">
                </div>
            </div>

            <div class="box-light" id="paquetes">
                <p class="title-secondary" style="color: white"><span>Comece a assinar</span><br>com FAD® agora</p>
                <div class="wrapper">
                    <div class="column">
                        <img src="assets/images/m/fadper.png" alt="">
                        <div class="content-column">
                            FAD®<br><span>PESSOAL</span><br>
                            <hr>

                            <hr style="margin: 5px 10%; width: 80%; height: 1px; background: white;">
                            <p class="light">
                                <strong>Inclui processo patenteado:</strong><br>
                                Vídeo assinatura, vídeo de aceitação do acordo, constância de conservação
                            </p>
                            <hr style="margin: 5px 10%; width: 80%; height: 1px; background: white;">
                            <p class="light">
                                <strong>Suporte:</strong><br>
                                N1 Call center de segunda a sexta das 8h às 20h.
                            </p>
                            <hr style="margin: 5px 10%; width: 80%; height: 1px; background: white;">
                            <p class="light">
                                <strong>Inclui:</strong><br>
                                Apenas aplicativo nativo (iOS e Android)
                            </p>
                            <hr style="margin: 5px 10%; width: 80%; height: 1px; background: white;">
                            <div class="buttons">
                                <div class="btn-back">
                                    <p id="ver_plan_persona_movil" (click)="addDataLayerClicProducto(1)">
                                        Compre Agora</p>
                                </div>
                                <div class="btn">
                                    <p (click)="login(false)">Teste<br>grátis</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="column">
                        <img src="assets/images/m/fademp.png" alt="">
                        <div class="content-column">
                            <p class="red">FAD®<br><span>EMPRESARIAL</span></p>
                            <hr class="hr-red">

                            <hr style="margin: 5px 10%; width: 80%; height: 1px; background: white;">
                            <p class="light">
                                <strong>Inclui processo patenteado:</strong><br>
                                Vídeo assinatura, vídeo de aceitação do acordo, constância de conservação
                            </p>
                            <hr style="margin: 5px 10%; width: 80%; height: 1px; background: white;">
                            <p class="light">
                                <strong>Suporte:</strong>
                                <br>
                                N1 Call center de segunda a sexta das 8h às 20h. (N2 com custo extra)
                            </p>
                            <hr style="margin: 5px 10%; width: 80%; height: 1px; background: white;">
                            <p class="light">
                                <strong>Inclui:</strong><br>
                                App Nativo (iOS e Android)
                                <br><strong style="font-size: 12px;">* Você pode adquirir Versão Web, SDK e API
                                separadamente</strong>
                            </p>
                            <hr style="margin: 5px 10%; width: 80%; height: 1px; background: white;">
                            <div class="buttons">
                                <div class="btn-back">
                                    <p id="ver_plan_empresa_movil" (click)="addDataLayerClicProducto(2)">
                                        Compre Agora</p>
                                </div>
                                <div class="btn">
                                    <p (click)="login(false)">Teste<br>grátis</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="content-general">

                <div class="fad-movil">
                    <img src="assets/images/m/comprafad.svg">
                </div>

                <p class="title-secondary left-mov">Como<br><span>comprar FAD®?</span></p>
                <ul class="content-list none">
                    <div class="icon">
                        <div class="icon8"></div>
                    </div>
                    <li>01 <span>Escolha</span></li>
                    <p>entre FAD® Pessoal ou<br>FAD® Empresarial</p>
                    <div class="icon">
                        <div class="icon9"></div>
                    </div>
                    <li>02 <span>Selecione </span></li>
                    <p>assinatura ou pacote</p>
                    <div class="icon">
                        <div class="icon11"></div>
                    </div>
                    <li>03 <span>Contate-nos</span></li>
                    <p>Via WhatsApp...</p>
                    <div class="icon">
                        <div class="icon10"></div>
                    </div>
                    <li>04 <span>Aproveite </span></li>
                    <p>se quiser agregar funcionalidades extras, fale conosco via WhatsApp...</p>
                </ul>
            </div>
            <div class="box-inv-comp"></div>
        </div>

        <div class="box-container">

            <div class="content-general">

                <p class="title-secondary left-mov">Conheça as<br><span>funcionalidades<br>extras do FAD®</span></p>

                <div class="icon">
                    <div class="icon2"></div>
                </div>
                <p class="text"><span>Validação de vídeo de aceitação do acordo</span>
                    <br>Comparação entre o rosto durante o contrato de vídeo e a foto de identificação</p>

                <div class="icon">
                    <div class="icon3"></div>
                </div>
                <p class="text"><span>Validação de Vídeo assinatura </span>
                    <br>Comparação entre o rosto durante a vídeo assinatura e a foto do documento de identidade</p>

                <div class="icon">
                    <div class="icon4"></div>
                </div>
                <p class="text"><span>Constância de blockchain</span>
                    <br>Em Ethereum que garante que o documento assinado não será alterado</p>

                <div class="icon">
                    <div class="icon5"></div>
                </div>
                <p class="text"><span>Captura de identidade</span>
                    <br>Fotografia do documento de identidade em ambos os lados</p>

                <div class="icon">
                    <div class="icon6"></div>
                </div>
                <p class="text"><span>OTP via WhatsApp</span>
                    <br>Envio de código único pelo WhatsApp, para que o signatário abra o documento a ser assinado no
                    app FAD®</p>

                <div class="icon">
                    <div class="icon7"></div>
                </div>
                <p class="text"><span>Validação de assinatura</span>
                    <br>Comparação entre a assinatura no documento de identidade e a assinatura feita com o dedo</p>

                <div class="icon">
                    <div class="icon7"></div>
                </div>
                <p class="text"><span>Versão WEB</span>
                    <br>O signatário pode assinar documentos de qualquer navegador móvel sem baixar nenhum aplicativo
                </p>

                <div class="icon">
                    <div class="icon20"></div>
                </div>
                <p class="text"><span style="color: #a80a34;">Considerações importantes</span>
                    <br>1. Para fazer comparações de contrato de vídeo, assinatura de vídeo e assinatura, é necessário
                    adquirir a Captura de Identificação.<br>
                    2. Para adquirir Add-Ons, solicite-os com seu consultor de vendas por um custo extra.</p>

                <div class="content-res">
                    <img src="assets/images/m/telefonos.png" alt="">
                </div>

            </div>

            <div class="box-dark">
                <div class="container">
                    <p class="text">
                        A Assinatura Autógrafa Digital®<br>está em conformidade com<br>
                        <span>a Medida Provisória No 2.200-2, LGPD, as leis da UNCITRAL (ONU) e os novos regulamentos eIDAS, US ESIGN e UETA & ESIGN Act, entre outros regulamentos.</span>
                    </p>
                </div>
                <div class="boton">
                    <p id="ver_cumplimieno_legal_movil" class="text"
                       [routerLink]="['/conformidade-legal-da-assinatura-digital']">Veja a conformidade legal</p>
                </div>
            </div>
            <div class="img-top">
                <img src="assets/images/m/videoacuerdoantes.png" alt="">
            </div>

            <div class="content-general" style="margin-top: 120px;">
                <ul class="content-list square">
                    <li><br>100% legal</li>
                    <p>Apenas assinatura digital comprovada por teste</p>
                    <li><br>3 minutos</li>
                    <p>Tempo que leva para assinar com FAD®</p>
                    <li><br>90% de economia</li>
                    <p>Em horas e recursos para processos de assinatura</p>
                </ul>
            </div>
            <div class="boton-black">
                <p class="text" (click)="freeTest()">Eu quero um teste grátis</p>
            </div>
            <br>
        </div>

        <div class="box-container">
            <div class="fad-movil">
                <img src="assets/images/m/fadangel.png">
            </div>
            <div class="content-general">
                <p class="title-secondary">Para que<br><span>posso usar o FAD®?</span></p>
            </div>
            <div style="margin-bottom: 10px">
                <p class="text">
                    <strong>IMOBILIÁRIO - COMPRA / VENDA DE IMÓVEIS</strong><br>
                    Assinatura eletrônica para contratos de compra, venda ou aluguel de imóveis com vídeo assinatura,
                    vídeo de aceitação do acordo, geolocalização e constância de conservação aprovado pelas
                    autoridades...
                </p>
                <hr class="hr-casos">
                <p class="text">
                    <strong>AUTOMOBILÍSTICO - COMPRA / VENDA DE AUTOMÓVEIS</strong><br>
                    Celebração de contratos de compra, venda ou locação de automóveis, seja diretamente com agência,
                    seja entre pessoas físicas. O processo possui vídeo assinatura, vídeo de aceitação do acordo,
                    geolocalização e constância de conservação aprovado pelas autoridades...
                </p>
                <hr class="hr-casos">
                <p class="text">
                    <strong>BANCOS - CARTÃO DE CRÉDITO</strong><br>
                    Assinatura eletrônica para contratação de cartões de crédito com vídeo assinatura, vídeo de
                    aceitação do acordo, geolocalização e constância de conservação aprovado pelas autoridades...
                </p>
                <hr class="hr-casos">
                <p class="text">
                    <strong>ASSINATURA DE CONTRATOS COM FORNECEDORES</strong><br>
                    Assinatura eletrônica de contratos de cadastro de fornecedores com vídeo assinatura, vídeo de
                    aceitação do acordo, geolocalização e constância de conservação aprovado pelas autoridades...
                </p>
                <hr class="hr-casos">
            </div>
            <br>
            <div class="boton-black" style="margin: 15px 30px">
                <p id="ver_casos_usos_movil" class="text" (click)="moreUseCases()">VER MAIS CASOS DE USO</p>
            </div>
            <br>
        </div>

        <div class="box-container">

            <div class="content-general">
                <p class="title-secondary left-mov">Eles já usam<br><span>Assinatura<br>Autógrafa Digital</span>
                </p>
            </div>

            <div class="clients-images">

                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/1-A_C Contruccion.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/2-logo-abc-capital.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/3-logo-abisa.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/5-acil-mexico.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/6-acium.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/7-Actinver.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/8-advex.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/9-alianza-financiera-social.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/10-logo-alorica.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/11-logo-alpez.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/12-alpha credit.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/13-logo-amda.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/16-amex-corp.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/17-Anfexi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/18-aplika.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/19-arc-canto.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/20-logo-seguro-bx.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/22-arrendamiento-seguro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/23-arvizu-benitez.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/24-Aseguranzza.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/25-Aser promotora.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/26-aserta.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/27-ARCA.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/28-logo-asf.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/29-logo-atlas-desarrollos.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/30-logo-atradius.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/31-logo-attendo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/32-logo-axa-seguros.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/33-logo-ayudate.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/34-logo-aqua-farms.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/35-BAM.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/36-logo-mifel.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/37-Banco BASE.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/38-logo-bancoppel.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/39-bancosol.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/40-logo-bank-america.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/41-logo-bankingly.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/42-banorte.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/43-Banorte casa bolsa.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/44-Banregio.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/45-BC credit.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/46-logo-be-grand.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/47-logo-best-doctors.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/48-logo-blac-solutions.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/49-logo-blic.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/50-logo-blue-services.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/52-Boss.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/53-Boxnsuites.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/54-logo-brada.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/55-logo-britannia.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/57-BX.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/58-Capgemini.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/59-logo-casa-equis.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/60-logo-cementos-moctezuma.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/61-logo-central.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/62-CIBando.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/63-logo-club-de-rentas.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/64-logo-cooperativa-ahorro-credito.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/65-Corporacion multivac.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/66-logo-credenz.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/67-logo-credicaor.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/68-credifiel.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/69-logo-credijusto.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/70-credimon.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/71-logo-credit-suisse.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/72-Creditea.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/73-inversiones cuantico.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/74-logo-dafi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/75-logo-daimler.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/77-Dicofra.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/78-DigitNow.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/79-Dycsi.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/80-logo-bebe.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/81-logo-educacion.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/83-logo-engie.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/84-logo-epicbanc.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/85-escuela-idiomas.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/87-logo-fanda.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/88-logo-farmalisto.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/89-logo-fergo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/90-logo-figlosnte.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/91-Fimeco.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/92-logo-finacciona.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/93-logo-finamex.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/94-Finvivir.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/95-forjadores.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/96-logo-formatres38.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/97-logo-garantia-de-renta.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/98-logo-gas-royal.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/99-gemalto.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/101-logo-gm.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/102-GNP.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/103-Grupak.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/104-logo-grupo-aguacatero.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/105-Grupo Barvis.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/106-Grupo CTP.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/107-logo-empresarial-angeles.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/108-logo-grupo-garsa.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/109-logo-larrarte.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/110-logo-grupo-mk.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/111-logo-grupo-renovables.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/112-logo-tangassi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/113-logo-grupo-tierra-maya.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/114-logo-veintiuno cero.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/115-logo-vigia.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/116-logo-fintex.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/117-logo-salazar-seguros.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/119-logo-ideaconv.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/120-Impulso distrito.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/121-logo-inmobiliaria.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/122-Invex.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/123-logo-ipack.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/124-logo-jp-morgan.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/125-logo-jubicom.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/126-logo-karum.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/127-Kondinero.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/128-logo-lyl-servicios.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/129-logo-castellana.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/130-Lacerta.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/131-Lanapay.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/132-Lecto.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/133-liceo-britanico.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/134-logo-liftit.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/135-logo-lockton.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/136-logo-maletin-financiero.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/137-logo-maple-respiratory.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/138-logo-marnez.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/140-logo-maslow.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/141-logo-medica-movil.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/142- logo-medworks.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/143-logo-femsa.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/144-Metrocarrier.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/145-Mexidooro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/147-monex.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/149-Banco Multiva.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/150-logo-mvs-radio.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/151-Natgas.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/152-NewYorkLife.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/153-logo-novo-media.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/154-Oak leasing.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/155-logo-orbia.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/156-logo-pa-despues.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/157-logo-pichincha.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/158-logo-potenciadora.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/159-logo-power-golden.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/161-Proagro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/162-profuturo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/163-logo-proton.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/164-prudential.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/165-logo-consultoria-juridica.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/166-logo-red-girasol.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/167-Rilmliving.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/168-logo-roadis.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/169-Rockteck.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/170-logo-santander.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/172-seguros atlas.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/173-logo-seguros-potosi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/175-servnet.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/177-Sicrea.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/178-logo-soluciones-industriales.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/179-logo-sotiderc.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/181-logo-spt-seguros.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/182-SR pago.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/183-logo-srobredo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/184-logo-start-credit.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/185-logo-storm-group.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/186-Supplycredit.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px" src="assets/images/clientes/187-Sura.png"
                          alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/188-logo-tcpip.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/189-logo-tec.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/190-Tecsup.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/192-logo-thales.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/194-logo-tintorerias-max.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/196-todo-a-dollar.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/197-logo-torres-corzo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/198-Toyota.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/199-Tucasaexpress.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/200-Value.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/201-Vantis.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/202-Vavilco.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/203-Vector bolsa.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/204-logo-viac.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/205-Viajes el corte ingles.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/206-logo-vidacel.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/207-logo-vivaness.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/208-logo-vwfs.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/209-logo-yo-dispongo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/210-logo-zavala-aguilar.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/211-logo-compartamos.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/212-logo-axtelcorp.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/213-GENTERA_logotipo.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/216-logo-globalps.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/217-logo-amado.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/218-logo-fibrax.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/219-naturalle-inter.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/220-quality-copy.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/221-logo-lirmi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/222-logocg-systems.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/223-logo-4r.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/224-logo-ciclos.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/225-logo-amig.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/226-logo-vip.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/227-logo-hotamsat.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/229-logo-nhit.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/230-logo-koi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/232-logo-olian.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/233-logo-nova-aluminio.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/234-logo-supercredi.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/236-logo-investockly.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/237-logo-cj-prado.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/238-logo-insignia.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/239-logo-mysourcing.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/241-logo-cemex.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/242-logo-lacuna.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/243-logo-urban-town.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/244-logo-finser.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/246-logo-tu-hogar.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/248-logo-ecomaster.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/249-viena-imoveis.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/250-logo-saucer.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/251-logo-maia.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/252-logo-rodrigo-cesar.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/253-logo-lorian.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/254-logo-colegio-brasileiro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/255-logo-ambaya.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/256-logo-yastas.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/257-logo-grupo.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/258-logo-micro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/260-logo-yanapana.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/261-logo-produbanco.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/262-logo-segurosaurora.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/264-logo-lalonja.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/265-logo-unispan.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/268-logo-instituto-barong.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/269-logo-ubicanton.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/271-logo-ektaris.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/272-logo-camargo-agronegocios.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/273-logo-fundacion-social.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/274-logo-crescendo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/275-logo-zenbyte.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/276-logo-cafeyna.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/277-logo-emprenet.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/279-logo-eldefiar.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/281-logo-dinamica-logistica.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/282-logo-ubiqo.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/283-logo-softvaro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/284-logo-w2b.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/286-logo-escritorio-ribeiro.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/288-logo-noli-imoveis.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/289-logo-diartrading.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/292-logo-gestacore.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/294-logo-seguridad-total.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/295-logo-hekobi.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/296-logo-nova-select.jpg" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/297-logo-educando.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/298-logo-colegio-monte.png" alt=""></div>
                <div><img width="80px" style="margin: 10px 0; padding: 0 10px"
                          src="assets/images/clientes/300-logo-jamka.png" alt=""></div>
            </div>
        </div>
    </div>

</app-template>

<div class="container-ie" *ngIf="isIEOrEdge">
    <div class="data">
        <div class="title">
            <p>NAVEGADOR NO COMPATIBLE</p>
        </div>
        <div class="description">
            <p>
                Intenta probando con un navegador más actual.
            </p>
        </div>
        <img src="assets/images/no-compatible.png" alt="">
    </div>
</div>
